import React from "react";

const Topbar = ({ title, subtitle, children }) => (
  <div className="admin-topbar">
    <div>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
    {children && <div className="admin-actions">{children}</div>}
  </div>
);

export default Topbar;
